import { createStore } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import { MiddlewareRegistry, ReducerRegistry } from '.';
import './reducers';
import './middlewares';

const persistConfig = {
  key: 'collectionCache',
  storage,
  version: 0,
  whitelist: [
    'common',
    'onboarding',
    'dashboard',
    'walletHistory',
    'customers',
  ],
  stateReconciler: autoMergeLevel2,
};

export const getMiddleware = () => {
  let middlewares = [thunk];
  if (window._env_.NODE_ENV === 'development') {
    middlewares.push(logger);
    return composeWithDevTools(
      MiddlewareRegistry._applyMiddleware(...middlewares),
    );
  }
  return MiddlewareRegistry._applyMiddleware(...middlewares);
};

export const getReducers = () => {
  const rootReducer = ReducerRegistry.combineReducers();
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  return persistedReducer;
};

export default () => {
  const store = createStore(getReducers(), getMiddleware());
  const persistor = persistStore(store);
  return { store, persistor };
};
